import { ShippingMethods } from '@/enums/shippingMethod';

export const HOUSE_SHIPPING_METHOD_TRANSLATION_KEY = `itemPage.shippingOptions.shippingMethod.${ShippingMethods.HouseShipping}`;
